const routes = [
  //  Materiais
  {
    path: '/almoxarifado/item',
    name: 'item',
    component: () => import('@/views/sistema/almoxarifado/item/Item.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Item' }] },
  },
  {
    path: '/almoxarifado/item/novo',
    name: 'itemNew',
    component: () => import('@/views/sistema/almoxarifado/item/ItemNew.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Item' }, { title: 'Novo' }] },
  },
  {
    path: '/almoxarifado/item/:id/editar',
    name: 'itemUpdate',
    component: () => import('@/views/sistema/almoxarifado/item/ItemNew.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Item' }, { title: 'Editar' }] },
  },

  {
    path: '/almoxarifado/historico-de-requisicoes',
    name: 'requestHistory',
    component: () => import('@/views/sistema/almoxarifado/HistoricoDeRequisicoes.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Histórico de requisições' }] },
  },
  // Deposito
  {
    path: '/almoxarifado/deposito',
    name: 'deposit',
    component: () => import('@/views/sistema/almoxarifado/deposito/Deposito.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Depósito' }] },
  },
  {
    path: '/almoxarifado/deposito/novo',
    name: 'depositNew',
    component: () => import('@/views/sistema/almoxarifado/deposito/DepositoNew.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Depósito' }, { title: 'Novo' }] },
  },
  {
    path: '/almoxarifado/deposito/:id/editar',
    name: 'depositUpdate',
    component: () => import('@/views/sistema/almoxarifado/deposito/DepositoNew.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Depósito' }, { title: 'Editar' }] },
  },
  {
    path: '/almoxarifado/deposito/:id/visualizar',
    name: 'depositView',
    component: () => import('@/views/sistema/almoxarifado/deposito/DepositoNew.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Depósito' }], type: 'view' },
  },
  {
    path: '/almoxarifado/deposito/:idWarehouse/item/:idItem/historico-aplicacao',
    name: 'itemApplicationHistory',
    component: () => import('@/views/sistema/almoxarifado/deposito/HistoricoAplicacao.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Depósito' }, { title: 'Histórico de Aplicação' }] },
  },
  // Movimentação - Pai
  {
    path: '/almoxarifado/movimentacao',
    name: 'movement',
    component: () => import('@/views/sistema/almoxarifado/movimentacao/Movimentacao.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Movimentação' }], type: 'all' },
  },
  {
    path: '/almoxarifado/aplicacoes',
    name: 'application',
    component: () => import('@/views/sistema/almoxarifado/movimentacao/Aplicacoes.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Aplicações' }], type: 'all' },
  },
  {
    path: '/almoxarifado/movimentacao/novo',
    name: 'movementNew',
    component: () => import('@/views/sistema/almoxarifado/movimentacao/MovimentacaoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Movimentação' }, { title: 'Novo' }],
    },
  },
  {
    path: '/almoxarifado/movimentacao/:id/editar',
    name: 'movementUpdate',
    component: () => import('@/views/sistema/almoxarifado/movimentacao/MovimentacaoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Movimentação' }, { title: 'Editar' }],
    },
  },
  {
    path: '/almoxarifado/aquisicoes',
    name: 'acquisition',
    component: () => import('@/views/sistema/almoxarifado/aquisicao/Aquisicao.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Aquisições' }], type: 'restrict' },
  },
  {
    path: '/almoxarifado/aquisicoes/novo',
    name: 'acquisitionNew',
    component: () => import('@/views/sistema/almoxarifado/aquisicao/AquisicaoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Aquisições' }, { title: 'Novo' }],
      type: 'restrict',
    },
  },
  {
    path: '/almoxarifado/aquisicoes/:id/editar',
    name: 'acquisitionUpdate',
    component: () => import('@/views/sistema/almoxarifado/aquisicao/AquisicaoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Aquisições' }, { title: 'Editar' }],
    },
  },
  {
    path: '/almoxarifado/aquisicoes/:id/visualizar',
    name: 'acquisitionView',
    component: () => import('@/views/sistema/almoxarifado/aquisicao/AquisicaoView.vue'),
    meta: {
      breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Aquisições' }, { title: 'Visualizar' }],
    },
  },
  // Inventário
  {
    path: '/almoxarifado/inventario',
    name: 'inventory',
    component: () => import('@/views/sistema/almoxarifado/inventario/Inventario.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Inventário' }] },
  },
  {
    path: '/almoxarifado/inventario/novo-setup',
    name: 'inventoryNewSetup',
    component: () => import('@/views/sistema/almoxarifado/inventario/InventarioStartNew.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Inventário' }, { title: 'Novo' }] },
  },
  {
    path: '/almoxarifado/inventario/novo',
    name: 'inventoryNew',
    component: () => import('@/views/sistema/almoxarifado/inventario/InventarioNew.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Inventário' }, { title: 'Novo' }] },
  },
  {
    path: '/almoxarifado/inventario/:id/editar',
    name: 'inventoryUpdate',
    component: () => import('@/views/sistema/almoxarifado/inventario/InventarioNew.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Inventário' }, { title: 'Editar' }] },
  },
  {
    path: '/almoxarifado/inventario/:id/visualizar',
    name: 'inventoryView',
    component: () => import('@/views/sistema/almoxarifado/inventario/InventarioView.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Inventário' }, { title: 'Visualizar' }] },
  },
  {
    path: '/almoxarifado/inventario/:id/imprimir',
    name: 'inventoryPrint',
    component: () => import('@/views/sistema/almoxarifado/inventario/InventarioView2.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Inventário' }, { title: 'Relatório de Intervalo' }] },
  },
  //  Requisições
  {
    path: '/almoxarifado/requisicao',
    name: 'requestConfirm',
    component: () => import('@/views/sistema/almoxarifado/requisicao/Requisicao.vue'),
    meta: {
      breadcrumb: [{ title: 'Obra' }, { title: 'Controle de Obras' }, { title: 'Materiais' }],
    },
  },
  {
    path: '/almoxarifado/requisicao/novo',
    name: 'materialRequestNew',
    component: () => import('@/views/sistema/almoxarifado/requisicao/RequisicaoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Obra' }, { title: 'Controle de Obras' }, { title: 'Requisição' }, { title: 'Novo' }],
    },
  },
  {
    path: '/almoxarifado/requisicao/:id/editar',
    name: 'materialRequestUpdate',
    component: () => import('@/views/sistema/almoxarifado/requisicao/RequisicaoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Obra' }, { title: 'Controle de Obras' }, { title: 'Requisição' }, { title: 'Editar' }],
    },
  },
  {
    path: '/almoxarifado/requisicao/:id/imprimir',
    name: 'materialRequestPrint',
    component: () => import('@/views/sistema/almoxarifado/requisicao/RequisicaoPrint.vue'),
    meta: {
      breadcrumb: [{ title: 'Obra' }, { title: 'Controle de Obras' }, { title: 'Requisição' }, { title: 'Imprimir' }],
    },
  },
]

export default routes
